import { xor } from 'lodash/fp';
import { produce } from 'immer';
import { REHYDRATE } from 'app/store/types.js';
import {
    ADD_XML,
    CLEAR_FILTERS,
    REMOVE_XML,
    SELECT_NODE,
    SET_FILTER,
    SET_NOTES,
    SET_SEARCH_TERM,
    TOGGLE_GROUP
} from './types.js';

export const INITIAL_STATE = {
    xmls: {},
    notes: {},
    expandedGroups: [],
    selectedNode: null,
    filters: {},
    searchTerm: null
};

export const inventoryReducer = produce((draft, action) => {
    switch (action.type) {
        case ADD_XML: {
            const { filename, xmlStr } = action.payload;

            draft.xmls[filename] = xmlStr;

            break;
        }
        case REMOVE_XML: {
            const { filename } = action.payload;

            delete draft.xmls[filename];

            draft.expandedGroups = draft.expandedGroups.filter(
                (group) => !filename.startsWith(group)
            );

            if (draft.selectedNode && draft.selectedNode.startsWith(filename)) {
                draft.selectedNode = null;
            }

            break;
        }
        case TOGGLE_GROUP: {
            const { id } = action.payload;

            draft.expandedGroups = xor([id], draft.expandedGroups);

            break;
        }
        case SELECT_NODE: {
            const { id } = action.payload;

            draft.selectedNode = id;

            const source = id.substring(0, id.lastIndexOf('-'));

            if (!draft.expandedGroups.includes(source)) {
                draft.expandedGroups.push(source);
            }

            break;
        }
        case SET_FILTER: {
            const { name, value } = action.payload;

            if (value) {
                draft.filters[name] = value;
            } else {
                delete draft.filters[name];
            }

            break;
        }
        case CLEAR_FILTERS: {
            draft.filters = {};

            break;
        }
        case SET_SEARCH_TERM: {
            const { searchTerm } = action.payload;

            draft.searchTerm = searchTerm;

            break;
        }
        case SET_NOTES: {
            const { source, id, notes } = action.payload;

            draft.notes[source] ||= {};
            draft.notes[source][id] = notes;

            break;
        }
        case REHYDRATE:
            if ('inventory' in action.payload) {
                Object.assign(draft, action.payload.inventory);
            }
            break;
        default:
            break;
    }
}, INITIAL_STATE);
